export default {
	path: '/',
	icon: '',
	meta: {
		title: '财务核算中心'
	},
	children: [
		{
			path: '/',
			icon: '',
			meta: {
				title: '财务管理'
			},
			children: [
				{
					path: '/accounting/statistics/index',
					name: 'CWStatisticsIndex',
					icon: '',
					component: () => import('@/views/accounting/statistics'),
					power: 'admin/v1/kq/plan',
					meta: {
						title: '财务统计'
					}
				},
				{
					path: '/order/finance/water',
					name: 'FinanceWaterIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/finance/water'),
					meta: {
						title: '流水订单'
					}
				},
				{
					path: '/order/consult/pay',
					name: 'orderPayList',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/consult/pay'),
					meta: {
						title: '缴费列表'
					}
				},
				{
					path: '/order/finance/moveClassExamine',
					name: 'moveClassExamine',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/consult/moveClassExamine'),
					meta: {
						title: '转产品审核'
					}
				},
				{
					path: '/accounting/campusPayment/index',
					name: 'campusPayment',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/accounting/campusPayment/index'),
					meta: {
						title: '校区支付配置'
					}
				},
				{
					path: '/accounting/jialianPayment/index',
					name: 'jialianPayment',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/accounting/jialianPayment/index'),
					meta: {
						title: '嘉联账单明细'
					}
				},
				{
					path: '/accounting/jialianFeeConfig/index',
					name: 'jialianFeeConfig',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/accounting/jialianFeeConfig/index'),
					meta: {
						title: '嘉联手续费配置'
					}
				},
				{
					path: '/accounting/jialianAccountDetail/index',
					name: 'jialianAccountDetail',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/accounting/jialianAccountDetail/index'),
					meta: {
						title: '入账明细'
					}
				},
				{
					path: '/accounting/detailsOfAirBalance/index',
					name: 'detailsOfAirBalance',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/accounting/detailsOfAirBalance/index'),
					meta: {
						title: '空中余额明细'
					}
				},
				{
					path: '/order/studentExamine/index',
					name: 'studentExamine',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/order/studentExamine/index'),
					meta: {
						title: '学员姓名审核'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			meta: {
				title: '财务中间件'
			},
			children: [
				{
					path: '/mid/acset',
					name: 'acset',
					icon: '',
					component: () => import('@/views/accounting/middleButton/acset'),
					meta: {
						title: '账套列表'
					}
				},
				{
					path: '/mid/payee',
					name: 'payee',
					icon: '',
					component: () => import('@/views/accounting/middleButton/payee'),

					meta: {
						title: '收款-收款单'
					}
				},
				{
					path: '/mid/account',
					name: 'account',
					icon: '',
					component: () => import('@/views/accounting/middleButton/account'),
					meta: {
						title: '收款-到账单'
					}
				},
				{
					path: '/mid/contact',
					name: 'contact',
					icon: '',
					component: () => import('@/views/accounting/middleButton/contact'),
					meta: {
						title: '转账-往来转账'
					}
				},
				{
					path: '/mid/shishou',
					name: 'shishou',
					icon: '',
					component: () => import('@/views/accounting/middleButton/shishou'),
					meta: {
						title: '转账-实收结转'
					}
				},
				{
					path: '/mid/shouru',
					name: 'shouru',
					icon: '',
					component: () => import('@/views/accounting/middleButton/shouru'),
					meta: {
						title: '转账-收入结转'
					}
				},
				{
					path: '/mid/refund',
					name: 'refund',
					icon: '',
					component: () => import('@/views/accounting/middleButton/refund'),
					meta: {
						title: '付款-学员退费'
					}
				},
				{
					path: '/mid/baoxiao',
					name: 'baoxiao',
					icon: '',
					component: () => import('@/views/accounting/middleButton/baoxiao'),
					meta: {
						title: '付款-费用报销'
					}
				},
				{
					path: '/mid/baoxiaogys',
					name: 'baoxiaogys',
					icon: '',
					component: () => import('@/views/accounting/middleButton/baoxiaogys'),
					meta: {
						title: '转账-供应商结转'
					}
				},
				{
					path: '/mid/baoxian',
					name: 'baoxian',
					icon: '',
					component: () => import('@/views/accounting/middleButton/baoxian'),
					meta: {
						title: '付款-员工保险'
					}
				},
				{
					path: '/mid/gongzi',
					name: 'gongzi',
					icon: '',
					component: () => import('@/views/accounting/middleButton/gongzi'),
					meta: {
						title: '转账-工资计提'
					}
				},
				{
					path: '/mid/gongzifafang',
					name: 'gongzifafang',
					icon: '',
					component: () => import('@/views/accounting/middleButton/gongzifafang'),
					meta: {
						title: '付款-发放工资'
					}
				},
				{
					path: '/mid/shebaojiezhuan',
					name: 'shebaojiezhuan',
					icon: '',
					component: () => import('@/views/accounting/middleButton/shebaojiezhuan'),
					meta: {
						title: '转账-社保结转'
					}
				},
				{
					path: '/mid/baoxiangjj',
					name: 'baoxiangjj',
					icon: '',
					component: () => import('@/views/accounting/middleButton/baoxiangjj'),
					meta: {
						title: '付款-员工公积金'
					}
				},
				{
					path: '/mid/qitawl',
					name: 'qitawl',
					icon: '',
					component: () => import('@/views/accounting/middleButton/qitawl'),
					meta: {
						title: '转账-其他往来'
					}
				},
				{
					path: '/mid/yushoujiezhuan',
					name: 'yushoujiezhuan',
					icon: '',
					component: () => import('@/views/accounting/middleButton/yushoujiezhuan'),
					meta: {
						title: '转账-预收一次结转'
					}
				},
				{
					path: '/mid/xinzengjiezhuan',
					name: 'xinzengjiezhuan',
					icon: '',
					component: () => import('@/views/accounting/middleButton/xinzengjiezhuan'),
					meta: {
						title: '转账-合同负债结转'
					}
				},
				{
					path: '/mid/chongjianshouru',
					name: 'chongjianshouru',
					icon: '',
					component: () => import('@/views/accounting/middleButton/chongjianshouru'),
					meta: {
						title: '学员退费-冲减收入'
					}
				}
			]
		}
	]
}
